import Vue from 'vue'
import App from './App.vue'
import "chart.js"
import "hchs-vue-charts"
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.css'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

Vue.config.productionTip = false
Vue.use(window.VueCharts);
Vue.use(Vuetify);
Vue.use(VueSweetalert2);
export default new Vuetify({})

new Vue({
  render: h => h(App),
}).$mount('#app')


